<template>
  <div v-if="item">
    <div class="poster" @click="onClick(item.tmdb_id)">
      <!--  <router-link :to="'/watchlist/item/' + item.tmdb_id"> -->
      <img v-if="item.tmdb && item.tmdb.poster_url" class="poster-img" :src="posterUrl(item.tmdb.poster_path)" alt="" />
      <!-- </router-link> -->
    </div>

    <!-- bottom sheet with details-->
    <!-- movie details in bottom sheet -->
    <div v-if="bottom">
      <v-bottom-sheet :value="bottom" scrollable fullscreen>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="bottom = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <MovieDetailPage :tmdb_id="tmdb_id" />
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
    </div>
  </div>
</template>

<script>
import api from '@/assets/api'
import MovieDetailPage from './MovieDetailPage.vue'
export default {
  components: {
    MovieDetailPage,
  },
  props: {
    tmdb_id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      bottom: false,
      item: null,
    }
  },
  methods: {
    onClick(tmdb_id) {
      this.$emit('click', tmdb_id)
      this.bottom = true
    },
    posterUrl(poster_path, size = 300) {
      return `https://image.tmdb.org/t/p/w${size}${poster_path}`
    },
    async fetchData() {
      const x = await api.apiFetch(`/watchlistt/get-movie?tmdb_id=${this.tmdb_id}&light=true`)
      if (x.ok) {
        const j = await x.json()
        this.item = j
      }
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
.poster {
  margin: 5px;
  cursor: pointer;
}
.poster-img:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.6);
}
.poster-img {
  max-width: min(calc(50vw - 25px), 250px);
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
</style>
